import { createAction } from '@reduxjs/toolkit';
import { AnyAction } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { showNotificationAsync } from '../notifications/actions';
import { RootState } from '../store';
import * as collectionsService from './service';
import type { CollectionsDataModel } from './types';

export const setCollectionsRecords = createAction(
    '@@collections/SET_COLLECTIONS_RECORDS',
    (...payload: CollectionsDataModel[]) => ({ payload }),
);

export const setCollectionIdentifiers = createAction<Array<CollectionsDataModel['id']>>(
    '@@collections/SET_COLLECTIONS_IDENTIFIERS',
);

export const addNewCollectionIdentifiers = createAction<Array<CollectionsDataModel['id']>>(
    '@@collections/ADD_NEW_COLLECTIONS_IDENTIFIERS',
);

export const setCollectionsLoading = createAction<{
    isLoading: boolean;
}>('@@collections/SET_COLLECTIONS_LOADING');

export const removeCollectionRecord = createAction<CollectionsDataModel['id']>(
    '@@collections/REMOVE_COLLECTION',
);

export function loadCollectionsAsync(): ThunkAction<void, RootState, undefined, AnyAction> {
    return async (dispatch) => {
        dispatch(setCollectionsLoading({ isLoading: true }));

        try {
            const response = await collectionsService.loadCollections();

            dispatch(setCollectionsRecords(...response.records.collections));
            dispatch(setCollectionIdentifiers(response.collections));
        } catch (error) {
            dispatch(showNotificationAsync('Не удалось загрузить данные'));
        }

        dispatch(setCollectionsLoading({ isLoading: false }));
    };
}

export function loadCollectionAsync(
    collectionId: CollectionsDataModel['id'],
): ThunkAction<void, RootState, undefined, AnyAction> {
    return async (dispatch) => {
        dispatch(setCollectionsLoading({ isLoading: true }));

        try {
            const collection = await collectionsService.loadCollection(collectionId);

            dispatch(setCollectionsRecords(collection));
        } catch (error) {
            dispatch(showNotificationAsync('Не удалось загрузить коллекцию'));
        }

        dispatch(setCollectionsLoading({ isLoading: false }));
    };
}

export function removeCollectionAsync(
    collectionId: CollectionsDataModel['id'],
): ThunkAction<void, RootState, undefined, AnyAction> {
    return async (dispatch) => {
        try {
            await collectionsService.removeCollection(collectionId);
            dispatch(removeCollectionRecord(collectionId));
        } catch (error) {
            dispatch(showNotificationAsync('Не удалось удалить коллекцию'));
        }
    };
}
